import React, { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";
import PrivacyPolicyModal from "@/components/PrivacyPolicyModal";

const STORAGE_KEY = "feniks_cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);

  useEffect(() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY);
      if (!v) {
        // delay show a bit so it doesn't pop up before the page renders
        const t = setTimeout(() => setVisible(true), 800);
        return () => clearTimeout(t);
      }
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ accepted: true, ts: new Date().toISOString() })
      );
    } catch {}
    setVisible(false);
  };

  return (
    <>
      <PrivacyPolicyModal open={showPrivacy} onClose={() => setShowPrivacy(false)} />

      {visible && (
        <div
          data-testid="cookie-banner"
          role="dialog"
          aria-label="Informacja o plikach cookies"
          className="fixed bottom-0 left-0 right-0 z-[70] p-3 sm:p-5 pointer-events-none"
        >
          <div className="max-w-5xl mx-auto pointer-events-auto bg-zinc-950 text-white border border-zinc-800 shadow-2xl">
            <div className="flex flex-col sm:flex-row items-start sm:items-stretch gap-0">
              {/* Icon column */}
              <div className="hidden sm:flex shrink-0 w-14 bg-[var(--feniks-red)] items-center justify-center">
                <Cookie size={22} />
              </div>

              {/* Content */}
              <div className="flex-1 p-4 sm:p-5 sm:py-4">
                <div className="flex items-center gap-2 mb-1.5">
                  <Cookie size={16} className="text-[var(--feniks-red)] sm:hidden" />
                  <div className="font-display text-base tracking-tight">
                    Ciasteczka? Tylko niezbędne.
                  </div>
                </div>
                <p className="text-xs sm:text-[13px] text-zinc-400 leading-relaxed">
                  Strona używa wyłącznie niezbędnych plików cookies do działania
                  (sesja asystenta AI, ochrona Cloudflare). Nie zbieramy danych do
                  marketingu ani analityki.{" "}
                  <button
                    data-testid="cookie-learn-more-btn"
                    onClick={() => setShowPrivacy(true)}
                    className="underline text-white hover:text-[var(--feniks-red)] transition-colors"
                  >
                    Polityka prywatności
                  </button>
                  .
                </p>
              </div>

              {/* Action */}
              <div className="flex sm:items-stretch w-full sm:w-auto border-t sm:border-t-0 sm:border-l border-zinc-800">
                <button
                  data-testid="cookie-accept-btn"
                  onClick={accept}
                  className="flex-1 sm:flex-initial px-6 py-4 sm:py-0 sm:px-8 bg-[var(--feniks-red)] hover:bg-[var(--feniks-red-hover)] text-white text-xs font-bold uppercase tracking-widest transition-colors"
                >
                  Akceptuję
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
